import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../configs/axiosInstance";

export const getMobileAppScanReportsByDomain = createAsyncThunk(
  "mobileApp/getMobileAppScanReportsByDomain",
  async (assetId, { rejectWithValue }) => {
    try {
      const response = await API.get(`/account-service/v1/mobile-app-scan-reports/${assetId}/by-domain`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching mobile app scan reports");
    }
  }
);

const mobileAppSlice = createSlice({
  name: "mobileApp",
  initialState: {
    mobileAppReports: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearMobileAppReports: (state) => {
      state.reports = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
  builder
    .addCase(getMobileAppScanReportsByDomain.pending, (state) => {
      state.loading = true;
    })
    .addCase(getMobileAppScanReportsByDomain.fulfilled, (state, action) => {
      state.loading = false;
      state.mobileAppReports = action.payload.results || [];

    })
    .addCase(getMobileAppScanReportsByDomain.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
}
});

export const { clearMobileAppReports } = mobileAppSlice.actions;
export default mobileAppSlice.reducer;
